@if (viewModel$ | async; as vm) {

    <div>
        <div class="header">
            <div class="controls">
                <div class="buttons">
                    <button tdoe-button [matMenuTriggerFor]="menu">Export</button>
                    <mat-menu #menu="matMenu" xPosition="before">
                        <button mat-menu-item (click)="onExport('csv')">CSV</button>
                        <button mat-menu-item (click)="onExport('xlsx')">Excel</button>
                    </mat-menu>
                </div>
            </div>
        </div>
        <div class="table-title">
            <span>Error Data</span>
        </div>
        <div style="max-height: 80vh;overflow-y: auto;">
            <mat-table [dataSource]="vm.data" matSort *ngIf="vm.data && vm.columns" (matSortChange)="onSortChanged($event)">
            
                @for (col of vm.columns;track col) {
                    <ng-container [matColumnDef]="col.name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>
                            <span [innerText]="col.label"></span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let error">{{error[col.name] ?? '--'}}</mat-cell>
                    </ng-container>
                }

                <mat-header-row *matHeaderRowDef="vm.columnNames; sticky: true"></mat-header-row>
                <mat-row *matRowDef="let row; columns: vm.columnNames"></mat-row>

            </mat-table>
        </div>

        <mat-paginator
            #paginator
            [length]="vm.pagedData.totalRecords"
            [pageSize]="vm.pagedData.pageSize"
            [pageIndex]="vm.pagedData.pageIndex"
            [pageSizeOptions]="[25, 50, 100, 500, 1000]"
            [showFirstLastButtons]="false"
            (page)="onPageChanged($event)">
        </mat-paginator>
    </div>

} @else {
    <div class="skeleton-buttons">
        <ngx-skeleton-loader [theme]="{ 'width':'30%', 'min-width': '9rem','height': '2.5rem' }" count="2" appearance="line"/>
    </div>
    <ngx-skeleton-loader [theme]="{ 'height': '2rem' }" count="1" appearance="line"/>
    <ngx-skeleton-loader count="25" appearance="line"/>
}

